import styled from 'styled-components'

const Wrapper = styled.article`
button {
    margin: 10px;
}
`


export default Wrapper